<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">养护单位列表</div>
    </div>
    <div class="modul-content">
      <!-- 查询 -->
      <div class="query-form">
        <el-form :inline="true" :model="form" ref="form">
          <el-form-item label="单位名称" prop="equipmentTypeName">
            <el-input
              v-model="form.equipmentTypeName"
              clearable
              placeholder="请输入台账名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="tableReq(1)">查询</el-button>
          </el-form-item>
        </el-form>
        <el-form :inline="true">
          <el-form-item>
            <el-button @click="editRow">新增</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button 
                       @click="onExport">导出</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <el-table
        class="tableStyle"
        v-loading="loading"
        height="calc(100vh - 350px)"
        border
        style="width: 100%"
        :data="tableData"
        :header-cell-style="{background: '#FAFAFA', color: '#000000'}"
      >
        <el-table-column
          label="序号"
          align="center"
          type="index"
          width="50px"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="单位名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name1"
          label="关联桥梁"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name2"
          label="关联员工"
          align="center"
        ></el-table-column>
        <el-table-column prop="name3" label="操作" align="center">
          <template #default="scope">
            <el-button class="btn" type="text" @click="editRow(scope.row)"
              >编辑</el-button
            >
            <el-button class="btn" type="text" @click="delRow(scope.row)"
              >删除</el-button
            >
            <!-- <el-button class="btn"
                       type="text"
                       @click="detailsRow(scope.row)">下载</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!--  -->
      <div style="text-align: center; margin: 20px 0 0">
        <el-pagination
          @size-change="handleSizeChange"
          :hide-on-single-page="!total"
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 点击编辑或新增弹出框 -->
    <div
      class="caozuotianbiao"
      :style="caozuoxy == true ? 'display: none;' : ''"
    >
      <el-form class="caozuotianbiao-from" :model="FormData">
        <div class="modul-top">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">桥梁台账</div>
        </div>
        <div
          style="
            position: absolute;
            top: 15px;
            right: 15px;
            border-radius: 50%;
            overflow: hidden;
            width: 30px;
            height: 30px;
          "
          @click="quxiao"
        >
          <img
            src="../../../assets/image/old/删除@2x.png"
            alt="关闭"
            style="width: 100%; height: 100%"
          />
        </div>
        <el-row>
          <el-col :span="11">
            <el-form-item label="单位名称" label-width="80px">
              <el-input
                v-model="FormData.value"
                placeholder="请输入设备类型"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="关联桥梁" label-width="80px">
              <el-select
                v-model="FormData.value1"
                multiple
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="关联员工" label-width="80px">
              <el-select
                v-model="FormData.value2"
                multiple
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          style="
            text-align: right;
            position: absolute;
            bottom: 10px;
            right: 25px;
          "
        >
          <el-button @click="quxiao">取消</el-button>
          <el-button type="primary" @click="isOK">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelYanghu',

  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 10
      },
      loading: false,
      tableData: [],
      total: 0,
      caozuoxy: true,
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        },
        {
          value: '选项3',
          label: '蚵仔煎'
        },
        {
          value: '选项4',
          label: '龙须面'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      FormData: {
        value: '',
        value1: [],
        value2: []
      }
    }
  },

  mounted() {
    this.tableReq()
  },

  methods: {
    async tableReq(page) {
      this.loading = true
      if (page) {
        this.form.pageNum = page
      }
      let data = {
        ...this.form
      }
      console.log(data)
      let a = {
        name: 'XX路桥养护公司',
        name1: '新安江大桥',
        name2: '李师傅、王师傅'
      }
      setTimeout(() => {
        this.loading = false
        this.total = 30
        this.tableData = Array(30).fill(a)
      }, 1000)
      // const res = await this.$api.sendPost('/biEquipmentType/getBiEquipmentType', data);
      // if (res.errcode == 0) {
      //   if (res.data && res.data.list.length > 0) {
      //     this.tableData = res.data.list;
      //     this.total = res.data.total;
      //   } else {
      //     this.tableData = [];
      //   }
      // }
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.form.pageSize = val
      this.tableReq(1)
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.form.pageNum = val
      this.tableReq()
    },
    onExport() {},
    //编辑和新增
    editRow(data) {
      console.log(data)
      if (data.name != undefined) {
        this.FormData = {
          value: data.name,
          value1: data.name1.split('、'),
          value2: data.name2.split('、')
        }
      } else {
        this.FormData = {
          value: '',
          value1: [],
          value2: []
        }
      }
      this.caozuoxy = false
    },
    async isOK() {
      this.caozuoxy = true
      // this.loading = true;
      // console.log('请求体',this.addAndAmendData);
      // const res = await this.$api.sendPost('/bridgeStandingBook/saveOrUpdate', this.addAndAmendData);
      // this.loading = false
      // console.log('请求结果',res);
    },
    quxiao() {
      this.caozuoxy = true
    },
    //删除
    delRow(data) {
      console.log('删除')
    }
  }
}
</script>

<style lang="scss" scoped>
.caozuotianbiao {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.caozuotianbiao-from {
  width: 70%;
  height: 700px;
  background-color: #fff;
  text-align: left;
  padding: 20px;
  position: relative;
  padding-top: 60px;
  padding-left: 120px;

  .modul-top {
    position: absolute;
    left: 15px;
    top: 0;
  }
}
</style>
